import { render, staticRenderFns } from "./HtmlPrivacyContent.vue?vue&type=template&id=26639a6b&"
import script from "./HtmlPrivacyContent.vue?vue&type=script&lang=js&"
export * from "./HtmlPrivacyContent.vue?vue&type=script&lang=js&"
import style0 from "./HtmlPrivacyContent.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./HtmlPrivacyContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VContainer,VThemeProvider})
